import React from 'react';

export interface MapSearchDropdownProps {
  showTabs: boolean;
  showSearchResults: boolean;
  children: React.ReactNode;
}

export function MapSearchDropdown({ showTabs, showSearchResults, children }: MapSearchDropdownProps) {
  return (
    <div className="absolute z-40 w-full bg-white border rounded-md shadow-lg max-h-80 mt-1 flex flex-col overflow-hidden">
      {children}
    </div>
  );
}
